<div class="d-flex justify-content-between" *ngIf="content !== ''">
    <div>{{content}}</div>
    <div><span pTooltip="{{toolTip}}" tooltipPosition="bottom"><i class="pi pi-eye hand fs active"
                (click)="buttonClicked()" [class.disabled]="isDisabled"></i></span></div>
</div>